import React from "react";

type U2000LabelProps = {
  label?: string;
  required?: boolean;
  htmlFor?: string;
};

const U2000Label: React.FC<U2000LabelProps> = ({ label, required = false, htmlFor }) => {
  if (!label) return null;

  return (
    <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700 mb-1.5 select-none">
      {label}
      {required && (
        <span className="text-red-500 ml-1" aria-label="requis">
          *
        </span>
      )}
    </label>
  );
};

export default U2000Label;
